import { v4 as uuidv4 } from "uuid";
import type { IMessageAppService } from "./message-app-service.interface";
import type { SendNewTextMessageContentDTO, SendNewStickerMessageContentDTO } from "./shared/types";
import { IMessageDTO, IStickerMessageDTO, ITextMessageDTO } from "../../shared/dtos";
import { messageRepository } from "../../repo/message";
import { messageDomainService } from "../../domain/message";
import { ZEventTarget } from "../../shared/utils/z-event";
import { MessageEventMap, ReceiveNewMessageEvent } from "./shared/events";


class MessageAppService extends ZEventTarget<MessageEventMap> implements IMessageAppService {
	public async loadMessages(convId: string, opts?: any): Promise<IMessageDTO[]> {
		const messages = await messageRepository.loadMessages(convId, opts);
		const messageDtos: IMessageDTO[] = messages.map((message) => {
			return {
				type: message.type,

				msgId: message.msgId,

				cliMsgId: message.cliMsgId,
				fromUid: message.fromUid,
				toUid: message.toUid,

				ttl: message.ttl,
				sendDttm: message.sendDttm,
				localDttm: message.localDttm,
				serverTime: message.serverTime,

				content: message.content,

				urgency: message.urgency,

				e2eeStatus: message.e2eeStatus,
			};
		});
		return messageDtos;
	}

	public async sendNewTextMessage(
		content: SendNewTextMessageContentDTO,
	): Promise<ITextMessageDTO> {
		const textMessageEntity = await messageDomainService.sendNewTextMessage({
			type: "text",

			msgId: uuidv4(),

			cliMsgId: content.sendDttm.toString(),
			fromUid: content.fromUid,
			toUid: content.toUid,

			sendDttm: content.sendDttm,
			localDttm: content.localDttm,

			content: content.content,
		});

		const textMessageDTO: ITextMessageDTO = {
			type: textMessageEntity.type,

			msgId: textMessageEntity.msgId,

			cliMsgId: textMessageEntity.cliMsgId,
			fromUid: textMessageEntity.fromUid,
			toUid: textMessageEntity.toUid,

			ttl: textMessageEntity.ttl,
			sendDttm: textMessageEntity.sendDttm,
			localDttm: textMessageEntity.localDttm,
			serverTime: textMessageEntity.serverTime,

			content: textMessageEntity.content,

			urgency: textMessageEntity.urgency,

			e2eeStatus: textMessageEntity.e2eeStatus,
		};
		this.dispatchEvent(new ReceiveNewMessageEvent({...textMessageDTO}));

		return textMessageDTO;
	}

	public async sendNewStickerMessage(
		content: SendNewStickerMessageContentDTO,
	): Promise<IStickerMessageDTO> {
		const stickerMessageEntity = await messageDomainService.sendNewStickerMessage({
			type: "sticker",

			msgId: uuidv4(),

			cliMsgId: content.sendDttm.toString(),
			fromUid: content.fromUid,
			toUid: content.toUid,

			sendDttm: content.sendDttm,
			localDttm: content.localDttm,

			content: content.content,
		});

		const stickerMessageDTO: IStickerMessageDTO = {
			type: stickerMessageEntity.type,

			msgId: stickerMessageEntity.msgId,

			cliMsgId: stickerMessageEntity.cliMsgId,
			fromUid: stickerMessageEntity.fromUid,
			toUid: stickerMessageEntity.toUid,

			ttl: stickerMessageEntity.ttl,
			sendDttm: stickerMessageEntity.sendDttm,
			localDttm: stickerMessageEntity.localDttm,
			serverTime: stickerMessageEntity.serverTime,

			content: stickerMessageEntity.content,

			urgency: stickerMessageEntity.urgency,

			e2eeStatus: stickerMessageEntity.e2eeStatus,
		};
		this.dispatchEvent(new ReceiveNewMessageEvent({...stickerMessageDTO}));

		return stickerMessageDTO;
	}

	public async deleteMessagesByCliMsgIds(convId: string, cliMsgIds: string[]): Promise<void> {
		await messageRepository.deleteMessagesByCliMsgIds(convId, cliMsgIds);
	}
}

const messageAppService = new MessageAppService();
export default messageAppService;
